import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Equipment } from 'src/assets/types/interface/equipament.interface';
import { PaginatorInterface } from 'src/assets/types/interface/table-items.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EquipmentService {
  private readonly apiUrl = environment.WO_API_URL;
  constructor(private http: HttpClient) {}

  getEquipments(environmentUuid: string): Observable<Equipment[]> {
    const access_token = localStorage.getItem('access_token');
    return this.http.get<Equipment[]>(
      `${this.apiUrl}/equipment/${environmentUuid}/all`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      },
    );
  }

  getAllEquipments(
    take: number,
    page: number,
    filters?: {
      name?: string;
      companies?: string[];
      environments?: string[];
    },
  ): Observable<PaginatorInterface> {
    const access_token = localStorage.getItem('access_token');
    let params = new HttpParams().set('name', filters?.name || '');

    (filters?.companies || []).forEach((status) => {
      params = params.append('companies', status);
    });

    (filters?.environments || []).forEach((status) => {
      params = params.append('environments', status);
    });

    return this.http.get<PaginatorInterface>(
      `${this.apiUrl}/equipment/limit/${take}/page/${page}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        params,
      },
    );
  }

  createEquipment(
    environmentUuid: string | undefined,
    data: any,
  ): Observable<HttpResponse<Equipment>> {
    const access_token = localStorage.getItem('access_token');
    return this.http.post<Equipment>(
      `${this.apiUrl}/equipment/${environmentUuid}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        observe: 'response',
      },
    );
  }

  updateEquipment(
    environementUuid: string,
    data: any,
  ): Observable<HttpResponse<Equipment>> {
    const access_token = localStorage.getItem('access_token');
    return this.http.patch<Equipment>(
      `${this.apiUrl}/equipment/${environementUuid}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        observe: 'response',
      },
    );
  }

  deleteEquipment(equipment: Equipment): Observable<HttpResponse<Equipment>> {
    const access_token = localStorage.getItem('access_token');
    const dataEquipment = {
      serialNumber: equipment.serial_number ?? '',
      name: equipment.name,
      status: 'INACTIVE',
    };
    return this.http.patch<Equipment>(
      `${this.apiUrl}/equipment/${equipment.uuid}`,
      dataEquipment,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        observe: 'response',
      },
    );
  }

  getEquipment(equipmentUuid: string): Observable<Equipment> {
    const access_token = localStorage.getItem('access_token');
    return this.http.get<Equipment>(
      `${this.apiUrl}/equipment/${equipmentUuid}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      },
    );
  }
}
